'use client'
import Link from 'next/link'
import { Row, Col, Button } from 'antd'
import { LottiePlayer } from '@/components/LottiePlayer'

import NotFound from './not-found.json'
import { gridContainer } from './grids'
import { Container, MainAnimation, Message } from './styled'

export const NotFoundPage = () => {

  return (
    <Container>
      <Row justify='center'>
        <Col {...gridContainer}>
          <MainAnimation>
            <LottiePlayer
              autoplay
              loop
              src={NotFound}
              style={{ width: '100%' }}
            />
          </MainAnimation>
        </Col>
      </Row>
      <Row justify='center'>
        <Col>
          <Message>
            Desculpe! Esta página não existe!
          </Message>
        </Col>
      </Row>
      <Row justify='center'>
        <Col>
          <Link href='/'>
            <Button
              type='primary'
              shape='round'
            >
              Voltar
            </Button>
          </Link>
        </Col>
      </Row>
    </Container>
  )
}